import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const TestSuiteApi = {
    getTestChannel: (options?: BaseApiQueryOptions) => apiQueryOptions(['testSuite', 'getTestChannel'], (api) => api.testSuite.getTestChannel(), options),
    // Mutations, not queries: every call must hand out a fresh grant or post a batch, never a cached answer.
    lineProbeSession: (options?: BaseApiMutationOptions<ApiClient['testSuite']['lineProbeSession']>) =>
        apiMutationOptions((api) => api.testSuite.lineProbeSession, options),
    lineProbeStats: (options?: BaseApiMutationOptions<ApiClient['testSuite']['lineProbeStats']>) => apiMutationOptions((api) => api.testSuite.lineProbeStats, options)
};
